<div class="session-details-crd" [ngClass]="['session-details-crd' + sessionData.class]">
	<div class="session-details-crd__cnt before-after-theme">
		<div class="session-details-crd__date">
			<p class="session-details-crd__date__month sm text-uppercase">{{ sessionData.month }}</p>
			<p class="session-details-crd__date__day">{{ sessionData.day }}</p>
			<p class="session-details-crd__date__year sm text-uppercase">{{ sessionData.year }}</p>
		</div>
		<div class="session-details-crd__info">
			<p class="session-details-crd__datetime"><lu-icon icon="lu-time" class="session-details-crd__icon"></lu-icon>{{ sessionData.time_interval }}</p>
			<p *ngIf="!sessionData.isWebinar" class="session-details-crd__list-item"><lu-icon icon="lu-location" class="session-details-crd__icon icon-small"></lu-icon>{{ sessionData.location_title || sessionData?.location }}</p>
			<p *ngIf="sessionData.isWebinar" class="session-details-crd__list-item"><lu-icon icon="lu-webinar" class="session-details-crd__icon icon-small"></lu-icon>{{ 'lup.components.sessions.webinar_label' | translate }}</p>
			<p class="session-details-crd__list-item"><lu-icon icon="lu-users" class="session-details-crd__icon icon-small"></lu-icon>{{ sessionData.seats_available }}</p>
		</div>
	</div>
</div>
